import { CONFIG } from "../../config";
import { getTokenizedAxios } from "../../utils/axiosWithTokenGen";
import {
  MerchantInsightsParams,
  MerchantInsightsData,
} from "../../interfaces/merchantInsights.interface";

export async function getMerchantInsightsFromServer(
  params: MerchantInsightsParams
): Promise<MerchantInsightsData> {
  const axios = await getTokenizedAxios();
  const path = "/businesses/merchant-insights";
  return axios
    .get(CONFIG.ADMIN_SERVER.BASE_URL + path, { params })
    .then((r) => r.data);
}
